var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 3605,
    viewBox: "0 0 1440 3605",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M221.503 1C502.976 32.6164 1365.65 236.24 1323.55 528.882C1259.5 974.118 68.5026 365.109 65.5026 1014.02C62.5026 1662.93 1160 802.039 1355.5 1314.78C1551 1827.53 580.002 1926.29 368.502 1837.01C157.002 1747.72 -114.497 1769.67 -184.497 1884.39C-254.497 1999.11 -175.498 2155.23 22.6785 2233.12C220.855 2311.01 1066.08 1967.17 1438.04 2210.09C1504.03 2253.18 1546.12 2307.14 1566.1 2366.21",
    stroke: "#00AEC0",
    strokeLinecap: "round",
    strokeDasharray: "24 24"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_2495_4465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.874 25.6299L375.29 25.1698C373.765 23.9694 371.964 23.1545 370.047 22.7974L365.78 22.075L359.115 5.80645C359.061 5.67541 358.972 5.56094 358.857 5.4754L357.133 4.19052C356.86 3.98692 356.472 4.19544 356.503 4.52956L357.896 19.6989C357.942 20.2054 357.487 20.6138 356.976 20.5238L346.172 18.6188C345.537 18.5078 344.996 18.1008 344.721 17.5284L342.852 13.6412C342.633 13.1862 342.244 12.831 341.765 12.6504L340.375 12.1257C340.24 12.0746 340.097 12.1786 340.109 12.3201L340.523 17.392C340.526 17.4291 340.524 17.4664 340.516 17.5028L340.429 17.9086C340.391 18.082 340.238 18.2073 340.057 18.2125L338.875 18.2464C338.661 18.2525 338.611 18.5413 338.81 18.6192L339.85 19.0264C340.03 19.0967 340.132 19.2836 340.092 19.4683L340.01 19.8492C340.002 19.8855 339.989 19.9205 339.971 19.9531L337.503 24.4065C337.434 24.5307 337.521 24.6839 337.665 24.6929L339.149 24.7847C339.66 24.8164 340.161 24.6524 340.548 24.3273L343.852 21.5515C344.34 21.1418 345.003 20.9932 345.627 21.1534L356.198 23.8495C356.7 23.9775 356.946 24.5362 356.695 24.9784L349.278 38.0426C349.112 38.3346 349.379 38.6837 349.712 38.6102L351.819 38.1451C351.955 38.1149 352.081 38.0494 352.183 37.9555L364.884 26.2313L369.103 27.1737C370.998 27.6344 372.975 27.6301 374.86 27.1614L375.583 26.9817C376.212 26.8253 376.383 26.0305 375.874 25.6299Z",
    fill: "#00AEC0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dddd_2495_4465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1274.45 633.457L1275.46 632.904C1278.08 631.461 1280.32 629.396 1281.98 626.893L1285.57 621.277L1312.73 621.576C1312.95 621.578 1313.17 621.521 1313.36 621.409L1316.22 619.735C1316.68 619.469 1316.61 618.795 1316.12 618.638L1293.67 611.524C1292.92 611.286 1292.62 610.396 1293.05 609.726L1302.24 595.551C1302.78 594.718 1303.68 594.194 1304.66 594.147L1311.32 593.827C1312.1 593.79 1312.84 593.45 1313.38 592.88L1314.96 591.224C1315.12 591.062 1315.05 590.798 1314.84 590.73L1307.37 588.279C1307.32 588.261 1307.26 588.235 1307.22 588.202L1306.69 587.835C1306.47 587.678 1306.38 587.386 1306.48 587.126L1307.14 585.429C1307.26 585.123 1306.88 584.879 1306.65 585.114L1305.44 586.345C1305.24 586.557 1304.91 586.591 1304.67 586.423L1304.18 586.079C1304.13 586.046 1304.09 586.006 1304.05 585.961L1299.19 579.794C1299.05 579.622 1298.78 579.653 1298.68 579.852L1297.66 581.901C1297.31 582.606 1297.24 583.415 1297.48 584.158L1299.45 590.505C1299.74 591.442 1299.56 592.471 1298.95 593.26L1288.78 606.63C1288.3 607.265 1287.35 607.279 1286.87 606.658L1272.71 588.315C1272.39 587.905 1271.73 588.075 1271.64 588.591L1271.04 591.856C1271 592.068 1271.02 592.285 1271.09 592.486L1280.18 617.516L1276.31 622.933C1274.52 625.343 1273.34 628.149 1272.88 631.102L1272.7 632.234C1272.55 633.219 1273.58 633.939 1274.45 633.457Z",
    fill: "#00AEC0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dddd_2495_4465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1696 954.698L70.8629 953.785C72.6717 951.402 73.8761 948.607 74.3693 945.648L75.3553 939.062L100.298 928.312C100.499 928.225 100.673 928.085 100.802 927.906L102.735 925.214C103.041 924.787 102.707 924.198 102.192 924.255L78.7866 926.863C78.0051 926.95 77.3599 926.262 77.4835 925.473L80.0971 908.796C80.2493 907.817 80.8618 906.971 81.7381 906.53L87.6895 903.537C88.386 903.187 88.9232 902.576 89.1877 901.835L89.9562 899.68C90.031 899.47 89.8659 899.254 89.6475 899.277L81.8204 900.07C81.7632 900.076 81.7054 900.073 81.649 900.062L81.019 899.94C80.7498 899.888 80.5515 899.656 80.5379 899.378L80.4493 897.56C80.4333 897.231 79.9854 897.163 79.871 897.472L79.2734 899.084C79.1703 899.363 78.8845 899.526 78.5978 899.47L78.0066 899.356C77.9502 899.345 77.8957 899.326 77.8448 899.299L70.8855 895.638C70.6914 895.536 70.4572 895.675 70.4478 895.897L70.3512 898.182C70.318 898.969 70.5868 899.735 71.1011 900.32L75.493 905.317C76.1411 906.055 76.3912 907.07 76.1627 908.036L72.319 924.378C72.1365 925.155 71.2804 925.55 70.5893 925.177L50.1684 914.168C49.712 913.922 49.1805 914.344 49.3044 914.854L50.0879 918.079C50.1387 918.289 50.2437 918.48 50.3921 918.634L68.9033 937.811L67.5759 944.331C66.9219 947.259 66.989 950.3 67.7713 953.186L68.0711 954.292C68.3322 955.254 69.566 955.494 70.1696 954.698Z",
    fill: "#00AEC0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dddd_2495_4465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1351.7 1573.68L1352.52 1572.88C1354.68 1570.81 1356.31 1568.24 1357.26 1565.39L1359.27 1559.04L1385.59 1552.32C1385.81 1552.27 1386 1552.16 1386.16 1552L1388.49 1549.64C1388.86 1549.27 1388.62 1548.64 1388.1 1548.61L1364.58 1547.53C1363.79 1547.5 1363.26 1546.72 1363.51 1545.96L1368.71 1529.89C1369.01 1528.95 1369.75 1528.21 1370.68 1527.91L1377.03 1525.88C1377.77 1525.65 1378.4 1525.13 1378.78 1524.44L1379.88 1522.43C1379.98 1522.23 1379.85 1521.99 1379.63 1521.98L1371.78 1521.54C1371.72 1521.54 1371.67 1521.53 1371.61 1521.51L1371.01 1521.29C1370.75 1521.2 1370.59 1520.94 1370.62 1520.66L1370.82 1518.85C1370.85 1518.52 1370.42 1518.39 1370.26 1518.67L1369.42 1520.17C1369.27 1520.43 1368.96 1520.55 1368.69 1520.45L1368.12 1520.24C1368.07 1520.22 1368.02 1520.2 1367.97 1520.16L1361.67 1515.46C1361.5 1515.33 1361.25 1515.43 1361.2 1515.65L1360.75 1517.89C1360.59 1518.66 1360.74 1519.46 1361.15 1520.12L1364.71 1525.74C1365.23 1526.57 1365.32 1527.61 1364.94 1528.53L1358.58 1544.07C1358.28 1544.81 1357.37 1545.06 1356.74 1544.59L1338.3 1530.52C1337.89 1530.21 1337.3 1530.54 1337.34 1531.07L1337.61 1534.37C1337.63 1534.59 1337.7 1534.79 1337.82 1534.97L1353.1 1556.8L1350.76 1563.03C1349.66 1565.82 1349.25 1568.84 1349.56 1571.81L1349.69 1572.95C1349.79 1573.94 1350.97 1574.37 1351.7 1573.68Z",
    fill: "#00AEC0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dddd_2495_4465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1357.79 2867.34L1358.94 2867.44C1361.92 2867.7 1364.93 2867.23 1367.71 2866.07L1373.82 2863.4L1396.22 2878.74C1396.4 2878.86 1396.61 2878.94 1396.83 2878.95L1400.15 2879.15C1400.67 2879.18 1400.99 2878.58 1400.67 2878.18L1386 2859.8C1385.51 2859.19 1385.75 2858.28 1386.49 2857.96L1402.03 2851.29C1402.94 2850.9 1403.99 2850.97 1404.83 2851.47L1410.54 2854.9C1411.2 2855.31 1412.01 2855.44 1412.78 2855.26L1415.02 2854.77C1415.23 2854.72 1415.33 2854.46 1415.19 2854.29L1410.35 2848.1C1410.32 2848.06 1410.29 2848.01 1410.27 2847.95L1410.04 2847.36C1409.94 2847.1 1410.03 2846.81 1410.26 2846.65L1411.75 2845.61C1412.03 2845.42 1411.84 2845.01 1411.52 2845.07L1409.84 2845.43C1409.54 2845.49 1409.25 2845.33 1409.15 2845.06L1408.93 2844.5C1408.91 2844.45 1408.9 2844.39 1408.89 2844.34L1408.29 2836.51C1408.28 2836.29 1408.04 2836.17 1407.84 2836.28L1405.85 2837.41C1405.17 2837.8 1404.66 2838.44 1404.44 2839.18L1402.53 2845.55C1402.25 2846.49 1401.52 2847.24 1400.58 2847.56L1384.67 2853.02C1383.91 2853.28 1383.12 2852.76 1383.07 2851.98L1381.54 2828.88C1381.51 2828.36 1380.87 2828.14 1380.5 2828.51L1378.18 2830.89C1378.03 2831.04 1377.92 2831.23 1377.87 2831.44L1371.45 2857.28L1365.21 2859.63C1362.38 2860.64 1359.83 2862.31 1357.8 2864.51L1357.02 2865.35C1356.34 2866.08 1356.8 2867.25 1357.79 2867.34Z",
    fill: "#00AEC0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dddd_2495_4465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.7502 3572.34L91.813 3571.2C91.9769 3568.21 91.4086 3565.22 90.1585 3562.49L87.2843 3556.48L101.936 3533.66C102.054 3533.47 102.12 3533.26 102.126 3533.04L102.22 3529.73C102.235 3529.2 101.627 3528.9 101.232 3529.24L83.2902 3544.46C82.6912 3544.96 81.7707 3544.75 81.4312 3544.03L74.2491 3528.75C73.8264 3527.85 73.8603 3526.81 74.3397 3525.95L77.5957 3520.15C77.9767 3519.47 78.08 3518.67 77.8835 3517.9L77.3128 3515.69C77.2573 3515.47 76.9993 3515.39 76.8307 3515.53L70.7864 3520.55C70.7422 3520.59 70.6929 3520.62 70.64 3520.64L70.0492 3520.89C69.7968 3521 69.5025 3520.92 69.3354 3520.69L68.2428 3519.23C68.0453 3518.97 67.6358 3519.16 67.714 3519.48L68.1225 3521.15C68.193 3521.44 68.0476 3521.74 67.7787 3521.85L67.2244 3522.09C67.1715 3522.11 67.1156 3522.12 67.0584 3522.13L59.237 3522.98C59.0188 3523 58.9023 3523.25 59.0192 3523.44L60.2199 3525.38C60.6332 3526.05 61.2859 3526.54 62.0402 3526.74L68.4823 3528.43C69.4331 3528.68 70.2094 3529.38 70.5614 3530.31L76.5359 3546C76.8196 3546.75 76.3316 3547.55 75.5497 3547.63L52.4487 3549.89C51.9323 3549.95 51.7282 3550.59 52.1168 3550.95L54.5745 3553.18C54.7339 3553.33 54.9282 3553.43 55.1373 3553.47L81.2341 3559.05L83.7881 3565.19C84.8873 3567.98 86.648 3570.47 88.9139 3572.42L89.7824 3573.17C90.5385 3573.82 91.6955 3573.33 91.7502 3572.34Z",
    fill: "#00AEC0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_dddd_2495_4465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.751 1783.68L132.716 1784.3C135.233 1785.92 138.117 1786.91 141.113 1787.18L147.769 1787.67L160.382 1811.68C160.484 1811.87 160.637 1812.03 160.826 1812.15L163.662 1813.87C164.111 1814.14 164.675 1813.77 164.579 1813.26L160.222 1790.17C160.076 1789.4 160.715 1788.71 161.513 1788.77L178.38 1790.12C179.37 1790.2 180.261 1790.75 180.767 1791.59L184.205 1797.28C184.607 1797.95 185.257 1798.44 186.019 1798.64L188.23 1799.25C188.445 1799.31 188.649 1799.13 188.61 1798.91L187.232 1791.18C187.222 1791.13 187.22 1791.07 187.227 1791.01L187.301 1790.38C187.334 1790.11 187.55 1789.89 187.827 1789.86L189.638 1789.63C189.965 1789.59 190 1789.14 189.683 1789.05L188.026 1788.58C187.74 1788.49 187.556 1788.22 187.59 1787.93L187.66 1787.34C187.667 1787.28 187.682 1787.22 187.705 1787.17L190.843 1779.97C190.931 1779.77 190.775 1779.55 190.552 1779.56L188.26 1779.63C187.472 1779.66 186.725 1779.98 186.179 1780.54L181.512 1785.28C180.824 1785.98 179.828 1786.31 178.845 1786.15L162.221 1783.55C161.431 1783.43 160.972 1782.61 161.293 1781.89L170.77 1760.75C170.982 1760.28 170.52 1759.78 170.02 1759.94L166.854 1760.97C166.649 1761.03 166.465 1761.15 166.323 1761.31L148.537 1781.16L141.921 1780.33C138.945 1779.89 135.909 1780.19 133.084 1781.18L132.001 1781.56C131.058 1781.9 130.911 1783.14 131.751 1783.68Z",
    fill: "#00AEC0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_2495_4465",
    x: 331.645,
    y: 2.8133,
    width: 50.3627,
    height: 55.9073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.648403
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.972605
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.24201
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.62101
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2495_4465",
    result: "effect2_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.78084
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.26941
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2495_4465",
    result: "effect3_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.2649
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.91781
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2495_4465",
    result: "effect4_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_2495_4465",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddd_2495_4465",
    x: 1262.02,
    y: 577.682,
    width: 63.5117,
    height: 86.9288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2495_4465",
    result: "effect2_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2495_4465",
    result: "effect3_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2495_4465",
    result: "effect4_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_2495_4465",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dddd_2495_4465",
    x: 40.2852,
    y: 893.604,
    width: 71.5664,
    height: 92.572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2495_4465",
    result: "effect2_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2495_4465",
    result: "effect3_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2495_4465",
    result: "effect4_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_2495_4465",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dddd_2495_4465",
    x: 1328.34,
    y: 1513.4,
    width: 69.3281,
    height: 91.6164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2495_4465",
    result: "effect2_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2495_4465",
    result: "effect3_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2495_4465",
    result: "effect4_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_2495_4465",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dddd_2495_4465",
    x: 1347.7,
    y: 2826.32,
    width: 76.5586,
    height: 83.8259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2495_4465",
    result: "effect2_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2495_4465",
    result: "effect3_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2495_4465",
    result: "effect4_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_2495_4465",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dddd_2495_4465",
    x: 42.9141,
    y: 3513.46,
    width: 68.3047,
    height: 91.01,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2495_4465",
    result: "effect2_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2495_4465",
    result: "effect3_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2495_4465",
    result: "effect4_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_2495_4465",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_dddd_2495_4465",
    x: 122.199,
    y: 1757.91,
    width: 77.668,
    height: 87.0483,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2495_4465",
    result: "effect2_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2495_4465",
    result: "effect3_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2495_4465",
    result: "effect4_dropShadow_2495_4465"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_2495_4465",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.5e97099ca643d072dfe7a2493e9dd525.svg";
export { ForwardRef as ReactComponent };